import { render, staticRenderFns } from "./businessUnitCommentsTab.vue?vue&type=template&id=399f1358&scoped=true&"
import script from "./businessUnitCommentsTab.vue?vue&type=script&lang=js&"
export * from "./businessUnitCommentsTab.vue?vue&type=script&lang=js&"
import style0 from "./businessUnitCommentsTab.vue?vue&type=style&index=0&id=399f1358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f1358",
  null
  
)

export default component.exports